"use strict";

class DevExtMappingController {

    constructor($scope, SSHttpService, SSUtilService, SSDateService, SSAwsService, SSAppService, SSAlertService, SSUserService, SSConfigService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAwsService = SSAwsService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;
        self.role_id = null;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        let self = this;

        self.extMappings = null;
        self.extMappingEditContainer = false;
        self.showAllowedTags = false;

        self.errorMessage = false;

        self.errField = '';
        self.errKey = '';
        self.errValue = '';
        self.initFields();
        self.extMappingKeys = self.SSConfigService.getExtMappingKeys();
        self.offset = 0;
        self.limit = 100;
        self.send_count = true;
        self.count = null;
        self.mapping_filter='salutations';
        self.getExtMappings();

    }

    getExtMappings() {
        let self = this;

        let url = 'sec/developer/ext-mapping';

            let params = {
                'filter_by':  self.mapping_filter,
                'limit': self.limit,
                'offset': self.offset,
                'count': self.send_count,
            };

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.clear();

            self.extMappings = response.data.ext_mappings;
            self.count = response.data.count;
        });
    }
    initFields(){
        let self = this;
        if(!self.entry){
            self.entry = {};
        }

        if(!self.entry.field){
            self.entry.field = '';
        }
        if(!self.entry.key){
            self.entry.key = '';
        }
        if(!self.entry.value){
            self.entry.value = '';
        }
    }

    toggleEditContainer() {
        const self = this;
            self.initFields();
            self.extMappingEditContainer = !self.extMappingEditContainer;
            jQuery('#extMappingEditContainer').modal(self.extMappingEditContainer ? 'show' : 'hide');

    }

    open(entry) {
        const self = this;

        if (entry) {
            self.entry = angular.copy(entry);
        }
        else{
            self.entry =null;
        }
        self.errorMessage = false;

        self.errField = '';
        self.errKey = '';
        self.errValue = '';
        self.initFields();

        self.toggleEditContainer();
    }

    postExtMapping() {
        const self = this;

        if (!self.validateExtMapping()) return;

        self.errorMessage = false;
        let url = 'sec/developer/ext-mapping';

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.entry).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');

            let entry = response.data.ext_mapping;

            if (!self.entry.id) {
                self.extMappings.push(entry);
            } else {
                jQuery.each(self.extMappings, function (i, e) {
                    if (e.id == entry.id) {
                        angular.merge(e, entry);
                        return false;
                    }
                });
            }

            self.toggleEditContainer();
        });
    }

    putExtMapping() {
        const self = this;

        if (!self.validateExtMapping()) return;

        self.errorMessage = false;
        let url = 'sec/developer/ext-mapping/'+self.entry.id;

        loading(true);
        self.SSHttpService.putAPIRequest(url, self.entry).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');

            let entry = response.data.ext_mapping;

            if (!self.entry.id) {
                self.extMappings.push(entry);
            } else {
                jQuery.each(self.extMappings, function (i, e) {
                    if (e.id == entry.id) {
                        angular.merge(e, entry);
                        return false;
                    }
                });
            }

            self.toggleEditContainer();
        });
    }


    validateExtMapping() {
        const self = this;

        let error = false;
        let re = /^[a-zA-Z0-9_]+$/;;
        self.errField = '';
        self.errKey = '';
        self.errValue = '';
        console.log(self.entry);
        if (!self.entry.field) {
            self.errField = 'Field is required';
            error = true;
        }
        if (!self.entry.key) {
            self.errKey = 'Key is required';
            error = true;
        }

        if (!self.entry.value) {
            self.errValue = 'Value is required';
            error = true;
        }
        return !error;
    }

    removeExtMapping(entry) {
        const self = this;
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this mapping?',
            self.SSConfirmationService.TYPE_DEFAULT,
                function () {
                let url = 'sec/developer/ext-mapping/' + entry.id +'/delete';
                let params = {
                    id: entry.id
                };

                loading(true);
                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    jQuery.each(self.extMappings, function (i, e) {
                        if (e.id == entry.id) {
                            self.extMappings.splice(i, 1);
                            return false;
                        }
                    });
                    self.SSAlertService.success('Removed successfully.');
                });
            }
        );
    }
    getKeyValue(key){
        const self= this;
        return self.SSConfigService.getExtMappingKeyValue(key)

    }
    filterFields(field){
        const self =this;
        self.mapping_filter = field;
        self.getExtMappings();
    }
}

DevExtMappingController.$inject = ['$scope', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAwsService', 'SSAppService', 'SSAlertService', 'SSUserService', 'SSConfigService', 'SSConfirmationService'];
app.controller('DevExtMappingController', DevExtMappingController);

